export default {"src":"/_next/static/media/product-menu-active.4558fd63.svg","height":32,"width":33};